import React, { PropsWithChildren } from 'react';
import { DividerVertical, NumberCardLayout, NumberCardTextLayout } from './NumberCard.style';
import { numberCardBanner } from '@assets/images/solution';
import { StyledDisplay, StyledHeading, StyledParagraph } from '@components/Text';
import { Trans } from 'react-i18next';
import { Spacing } from '@pages/CommonStyle/common.style';
import { DivAllCenter, DivFlexColumn, DivFlexRow } from '@pages/CommonStyle/commonDiv.style';
import { StyledGridContainer } from '@components/Grid/Grid.style';

interface ModalDefaultType {
  path: any;
}

const NumberCard: React.FC<PropsWithChildren<ModalDefaultType>> = ({ path }) => {
  const items = ['첫 번째', '두 번째', '세 번째']; // 👉 동적 배열 예시

  return (
    <NumberCardLayout img={numberCardBanner}>
      <StyledGridContainer>
        <DivAllCenter>
          <StyledDisplay size="small" color="#fff">
            <Trans i18nKey={path.numOfCard.title} />
          </StyledDisplay>
          <Spacing pixel="8" />
          <StyledParagraph size="medium" color="#fff">
            <Trans i18nKey={path.numOfCard.desc} />
          </StyledParagraph>
          <Spacing pixel="32" />

          <NumberCardTextLayout>
            {path.numOfCard.card.map((data, index) => (
              <React.Fragment key={index}>
                <DivFlexColumn>
                  <StyledDisplay size="small" color="#fff">
                    <Trans i18nKey={data.tag} />
                  </StyledDisplay>
                  <Spacing pixel="8" />
                  <StyledHeading size="xsmall" color="#fff">
                    <Trans i18nKey={data.title} />
                  </StyledHeading>
                  <StyledParagraph size="medium" color="#fff">
                    <Trans i18nKey={data.desc} />
                  </StyledParagraph>
                </DivFlexColumn>
                {index < path.numOfCard.card.length - 1 && <DividerVertical />}
              </React.Fragment>
            ))}
          </NumberCardTextLayout>
        </DivAllCenter>
      </StyledGridContainer>
    </NumberCardLayout>
  );
};

export default NumberCard;
